const BreakfastIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="#55B685"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20.8333 3.125H4.16666V13.5417C4.16666 15.8437 6.03124 17.7083 8.33332 17.7083H14.5833C16.8854 17.7083 18.75 15.8437 18.75 13.5417V10.4167H20.8333C21.9896 10.4167 22.9167 9.47917 22.9167 8.33333V5.20833C22.9167 4.05208 21.9896 3.125 20.8333 3.125ZM20.8333 8.33333H18.75V5.20833H20.8333V8.33333ZM4.16666 19.7917H20.8333V21.875H4.16666V19.7917Z" />
  </svg>
)

export default BreakfastIcon
